import React, { Component } from 'react';
import Footer from '../Footer/Footer';
import PostLink from './PostLink';
import MobileSlider from './MobileSlider';
import PostLoading from './PostLoading';
import ScrollToTop from '../ScrollToTop';
import 'nprogress/nprogress.css';
import { generateKey, applyPageBackground } from '../utils/utils.js';
import { Tag, BackgroundVideo, MobileEnterButton } from './styles/index';


class Work extends Component {
	state = {
		transitionLinksAll: 'no-transition',
		mobileEnter: false,
	};

	componentDidMount() {
		this.props.updateLocation();
		window.scrollTo(0, 0);
		applyPageBackground('transparent');
		if (this.props.filter) {
			this.setState({ mobileEnter: true });
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.filter !== this.props.filter && this.props.filter && !this.state.mobileEnter) {
			this.setState({ mobileEnter: true });
		}
	}

	enterSite = () => {
		this.setState({ mobileEnter: true });
	}

	render() {
		let allContent;
		let loadedContent;

		if (!this.props.filter) {
			loadedContent = this.props.allContent.map((item, index) => {
				if (index < 50 && item.fields) {
					return (
						<PostLink
							index={index}
							key={generateKey(index)}
							hoverVideo={this.activeTransition}
							postContent={item}
							allContent={this.props.allContent}
						/>
					);
				}
				return null;
			})
		} else {
			loadedContent = this.props.allContent.map((item, index) => {
				if (item.fields.tags && item.fields.tags[0] === this.props.filter) {
					return (
						<div className={item.fields.tags[0]}>
							<PostLink
								index={index}
								key={generateKey(index)}
								hoverVideo={this.activeTransition}
								postContent={item}
								allContent={this.props.allContent}
							/>
						</div>
					);
				}
				return null;
			})
		}


		let loading = <PostLoading key={generateKey(10)} />;
		this.props.allContent.length > 1 ? (allContent = loadedContent) : (allContent = loading);
		const mobileThum = this.props.mobileVideoThumbnail ? this.props.mobileVideoThumbnail.fields.file.url : ''
		return (
			<div className={`App work ${this.state.transitionLinksAll}`}>
				{!this.state.mobileEnter && (
					<BackgroundVideo className="mobile mobile-bcg">
						{!!this.props.mobileVideo &&
							<div>
								<video playsInline autoPlay muted loop poster={mobileThum} id="bgvid">
									<source src="polina.webm" type="video/webm" />
									<source src={this.props.mobileVideo.fields.file.url} type="video/mp4" />
								</video>
							</div>
						}
					</BackgroundVideo>
				)}
				{!this.state.mobileEnter && (
					<MobileEnterButton style={{ fontFamily: 'newFont, Sackers, sans-serif' }} onClick={this.enterSite}>Enter Site</MobileEnterButton>
				)}
				<ScrollToTop />
				<main className="desktop">
					{allContent}
				</main>
				<main className="mobile">
					{this.state.mobileEnter && allContent}
				</main>

				{/* <main className="mobile">
					{allContent}
					<div className="mobileSlider">
						<MobileSlider
							allContent={this.props.allContent}
							homepageMobilePosts={this.props.homepageMobilePosts}
						/>
					</div>
				</main> */}
				<div className="spacer" />
				<Tag style={{ fontFamily: 'newFont, Sackers, sans-serif' }}>{this.props.footerText}</Tag>
				<Footer />
			</div>
		);
	}
}

export default Work;
